import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=d254f046"
import script from "./Nosotros.vue?vue&type=script&lang=js"
export * from "./Nosotros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports